import { useSelector } from "react-redux";
import { RootState } from "@store/store";

const useInterfaceConfigV2 = () => {
  const interfaceConfig = useSelector((state: RootState) => state.theme.interface);
  return interfaceConfig;
};

export default useInterfaceConfigV2;
